<template>
  <div>
    <div class="card">
      <div style="margin: 0;font-size: 8px;" v-if="item.concerned && item.concerned.title">
        <el-dropdown trigger="click" placement="bottom-start" @command="changeItemConcerned">
          <el-button size="mini" type="text" style="color: #999" v-if="modifiable">{{ item.concerned.title | blankFmt }}&nbsp;<span
              class="el-icon-arrow-down"></span></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="itm in concernedList" :key="itm.id" :command="itm.id">{{itm.title}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span style="color: #999" v-if="!modifiable">{{ item.concerned.title | blankFmt }}</span>
      </div>
      <div v-if="modifiable" style="float: right; padding: 0 15px">
        <el-popconfirm title="您确定要将该项设置为推荐项吗？" @confirm="setSuggest()" v-if="!item.suggest" style="margin: 0 0 0 18px;">
          <el-button slot="reference" type="text" size="mini" icon="el-icon-star-off"
                     style="font-size: 16px"></el-button>
        </el-popconfirm>
        <el-popconfirm title="您确定要将该项设置为弃用的吗？" @confirm="setUnUse()" v-if="!item.unused" style="margin: 0 0 0 18px">
          <el-button slot="reference" type="text" size="mini" icon="el-icon-delete" style="font-size: 16px"></el-button>
        </el-popconfirm>
        <el-popconfirm title="您确定要将该项设置为不确定项吗？" @confirm="setOperaEmpty()" v-if="item.suggest || item.unused"
                       style="margin: 0 0 0 18px;">
          <el-button slot="reference" type="text" size="mini" icon="el-icon-s-order"
                     style="font-size: 16px"></el-button>
        </el-popconfirm>
      </div>
      <div style="padding: 5px 0">
        <div style="margin: 0">
          <h6 style="line-height: 1.4; text-align: justify; margin: 0; cursor: pointer; color: dodgerblue">
            <a @click.prevent="openLink(item.url)" style="cursor: pointer; ">
              <span v-if="item.unused" class="el-icon-delete" style="color: orange">已弃用</span>
              <span v-if="item.suggest" class="el-icon-star-on"
                    style="color: deepskyblue">建议项&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span v-if="!item.unused" class="el-icon-link"></span>&nbsp;<span v-if="index">{{
                index
              }}.</span>&nbsp;<span
                v-html="tt"></span>
            </a>
          </h6>
        </div>
      </div>
      <div style="font-size: 6px">
        <div>
          <span class="help-text text-nowrap" v-if="item.publishDate">
            <el-tag size="mini"><span class="el-icon-timer"></span>&nbsp;发布：{{ item.publishDate | blankFmt }}</el-tag>
          </span>
          <span class="help-text text-nowrap" v-if="item.openDate">
            <el-tag size="mini"><span class="el-icon-timer"></span>&nbsp;开标：{{
                item.openDate | blankFmt
              }}</el-tag></span>
        </div>
        <div style="margin: 3px 0">
          <div class="text-nowrap">
            <el-tag :type="highlightCustomer? 'warning': 'default'" v-if="item.customerName" style="margin-right: 15px"
                    size="mini" @click="showCompanyInfos">
              <span class="el-icon-office-building"></span>&nbsp;{{ item.customerName | blankFmt }}
            </el-tag>
            <el-tag size="mini"><span class="el-icon-monitor"></span>&nbsp;{{ item.webSiteName | blankFmt }}</el-tag>
          </div>
        </div>
        <div>
          <span class="color-red">
            <el-tag v-if="item.area" size="mini"><span
                class="el-icon-position"></span>&nbsp;{{ item.area | splitAtOne | blankFmt }}</el-tag>
          </span>
          <span style="float: right;vertical-align: middle;line-height: 1.8; display: inline-block">
            <span class="el-icon-timer"></span>采集：{{ item.fetchDate | blankFmt }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DailyReportItem from "@/models/DailyReportItem";
import {mapGetters} from "vuex";

export default {
  name: "DailyReportItemCard",
  filters: {
    splitAtOne(v) {
      if (!v) {
        return ""
      }
      return v.split("/")[0]
    }
  },
  props: {
    item: DailyReportItem,
    index: Number,
    highlightTitles: {
      type: Array,
      default: () => []
    },
    highlightCustomer: {
      type: Boolean,
      default: false
    },
    concernedList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      user: 'currentUser'
    }),
    tt() {
      let ret = this.item.title
      if (this.highlightTitles && this.highlightTitles.length) {
        let lst = this.highlightTitles
            .filter(t => this.item.title.indexOf(t) > -1)
            .sort((s1, s2) => s2.length - s1.length)
        for (let htt of lst) {
          ret = ret.replace(htt, "<span class='color-red'>" + htt + "</span>")
        }
      }
      return ret
    },
    modifiable() {
      return this.user.isLogined()
          && this.user.id === this.item.creator.id
    }
  },
  methods: {
    openLink(link) {
      open(link, "_blank")
    },
    setUnUse() {
      this.$emit('unuse', new DailyReportItem(this.item))
    },
    setSuggest() {
      this.$emit('suggest', new DailyReportItem(this.item))
    },
    setContinue() {
      this.$emit('continue', new DailyReportItem(this.item))
    },
    setOperaEmpty() {
      this.$emit('operaEmpty', new DailyReportItem(this.item))
    },
    showCompanyInfos() {
      this.$emit('showCustomerInfos', this.item.customerName)
    },
    changeItemConcerned(cid) {
      if (cid) {
        this.$emit('changeItemConcerned', {id: this.item.id, cid})
      }
    }
  }
}
</script>

<style scoped>

.title-sm {
  font-size: 12px;
  display: inline-block;
  width: 56px;
  text-align: justify-all;
  text-align-last: justify;
}

.el-card__header {
  padding: 5px 15px;
}

</style>
